import {Validator} from 'vee-validate';
import {BasicSelect} from 'vue-search-select';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
 import DatePicker from 'vue2-datepicker';
import CustomExpandableTable from '../../../../../shared/components/customExpandableTable';
import TripShipment from './../TripShipment';
import closeTrip from './../closeTrip';
import TripServices from './../../../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service';
import CONSTANT from './../../../../../shared/constants/constant';



export default {
  name: 'createTripManagement',
  components: {
    BasicSelect,
    DatePicker,
    CustomExpandableTable,
    closeTrip,
    TripShipment,
    VueElementLoading,
    TripServices,
    CONSTANT
  },
  props: ['parentObj'],
  data() {
    return {
      accordianTab:{1:false, 2:false},
      expanded:false,
      showDepartTrip:false,
      closeTrip:false,
      scanDocument: '',
      DEPSType: '',
      LoadInVehicle: '',
      MPS: '',
      showTripSheet: false,
      Loader: false,
      showGenerateTrip: false,
      tableColumn: ['MPS', 'AWB', 'DEPS Type','Loaded in Vehicle','Images','Action'],
      innerTableColumn: ['Assigned Zones'],
      tableItems: [],
      currentTab: 'First',
      componentKey:1,
      tabs: [
        { key:'First', value:'FirstMile' },
        { key:'Second', value:'LastMile' },
      ],
      isShortageLoader:false,
      notScannedMPS: [],
      selectedNotScannedMPS: [],
      markShortMPS: [],
      mpsError:'',
      AWB: '',
      depsTypeErr:'',
      loadErr:'',
      isDamageLoader: false,
      userName: '',
      userID: 0,
      showTable: true,
      damageMPS: [],
      scanStage: 'StartScan',
      MPSLengthLimit:CONSTANT.MPS_LENGTH_LIMIT,
      imagearray:[],
      imageerr:'',
      tempshow : false
    }
  },
  computed: {},
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userID = userdetail.userid
    this.userName = userdetail.email;
    this.HubId = userdetail.hubID[0];
    this.getDamageOrPilferageMpsData()
    this.getNotScannedMpsData();
    this.getMarkShortMPSData();
  },
  methods: {
    openImage(image) {
      // this.accordianTab[2] = false
      var modal = document.getElementById('myModalImg' + image);
      var img = document.getElementById('imgid' + image);
      var modalImg = document.getElementById("img" + image);
      var captionText = document.getElementById("captionImg" + image);
      modal.style.display = "block";
      modalImg.src = image;
      // captionText.innerHTML = this.podImage;
    },

    closemodal(id) {
      var modal = document.getElementById(id);
      modal.style.display = "none";
    },

    async removeMPSFromDeps(data){
      this.isDamageLoader = true
      let input = {
        tripid: this.parentObj.tripID,
        allocationtype: 'lastmile',
        awb: data.awb,
        mps: data.mps,
        scanstage: this.scanStage,
      }
      let result = await TripServices.removeMPSFromDeps(input);
      if(result.data.code == 200){
        this.$alert(result.data.message, "", "success");
        this.getDamageOrPilferageMpsData()
        this.getNotScannedMpsData()
      }else{
        this.$alert(result.data.message, "", "error");
      }
    },
    async selectRemove(data,index){
      this.isShortageLoader = true
      console.log("data",data)
      let payload = {
          tripid: data.tripid,
          awb: data.awb,
          mps: data.mps,
          allocationtype: 'LM',
          hubid: this.HubId,
          lastmodifiedby: this.userName,
          currentevent:'allocsr'
      }
      let result = await TripServices.RemoveFromShort(payload)
      console.log("result",result)
      this.isShortageLoader = false
      if(result.data.code == 200){
        this.$alertify.success("MPS Removed from short");
        this.getMarkShortMPSData()
      }else{
        this.$alertify.error(result.data.data.error);
      }
    },
    async handleFileUpload(event) {
      if (this.MPS) {
        this.isDamageLoader = true
        let uploadFile = event.target.files;
        this.imagearray = []
        let formData = new FormData();
        /*Add the form data we need to submit*/
        for (let key in uploadFile) {
          if (key >= 0) {
            if (uploadFile[key].type != "image/jpeg" &&
              uploadFile[key].type != "image/jpg" && uploadFile[key].type != "image/png") {
              this.$alertify.error("Please upload only valid file format");
              this.isDamageLoader = false
              return false
            }
          }
          if (uploadFile[key].size > (1024 * 1024 * 5)) {
            this.$alert(`${uploadFile[key].name} size is greater than 5MB`, "", "error");
            this.isDamageLoader = false
            return false
          } else {
            formData.append("file", uploadFile[key]);
          }
        }
        formData.append("mps", this.MPS);
        let result = await TripServices.uploadDocDocment(formData)
        if (result.data.code == 200) {
          result.data.data.map(obj => {
            this.imagearray.push(obj.Location)
          })
          this.$alertify.success("Images uploaded successfully !");
        }
        this.imageerr = ''
        this.isDamageLoader = false
      } else {
        this.mpsError = 'Please Scan MPS'
      }
    },

    async getDamageOrPilferageMpsData(){
      this.isDamageLoader = true
      this.damageMPS = []
      let input = {
        tripid: this.parentObj.tripID,
        scanstage: this.scanStage,
        shipmenttype: 'lastmile',
      }
      let result = await TripServices.getDamageOrPilferageMpsData(input);
      if(result.data.code == 200){
        this.damageMPS = result.data.data
        let imagearr = []
        this.damageMPS = result.data.data.map(obj => {
          imagearr = []
          for(let key in obj.images){
            imagearr.push(obj.images[key])
          }
          obj.imagearr = imagearr
          return obj
        })
        this.showTable = false
        this.showTable = true
      }
      this.isDamageLoader = false
    },

    async getNotScannedMpsData(){
      this.isShortageLoader = true
      this.notScannedMPS = []
      let input = {
        tripid: this.parentObj.tripID,
        scanstage: this.scanStage,
        shipmenttype: 'lastmile',
      }
      let result = await TripServices.getNotScanMps(input);
      if(result.data.code == 200){
        this.notScannedMPS = result.data.data
      }
      this.isShortageLoader = false
    },

    async getMarkShortMPSData(){
      this.isShortageLoader = true
      this.markShortMPS = []
      let input = {
        tripid: this.parentObj.tripID,
        scanstage: this.scanStage,
        shipmenttype: 'lastmile',
      }
      let result = await TripServices.getMarkShortMps(input);
      if(result.data.code == 200){
        this.markShortMPS = result.data.data
      }
      this.isShortageLoader = false
    },

    changeShortageTab(type){
      if(type == 'NotScanned'){
        this.getNotScannedMpsData()
      } else{
        this.getMarkShortMPSData()
      }
    },

    async markShortSelectedMPS(){
      this.isShortageLoader = true
      let input = {
        tripid: this.parentObj.tripID,
        scanstage: this.scanStage,
        shipmenttype: 'lastmile',
        mpsarray: this.selectedNotScannedMPS,
        createdby: this.userName
      }
      let result = await TripServices.markShortMultipleMPS(input);
      if(result.data.code == 200){
        this.$alert(result.data.message, "", "success");
        this.getNotScannedMpsData()
        this.selectedNotScannedMPS=[];
      }else{
        this.$alert(result.data.message, "", "error");
      }
      this.getMarkShortMPSData();
      this.isShortageLoader = false
    },

    async validateMPS(){
      if(this.MPS.length >= this.MPSLengthLimit){
        let input = {
          tripid: this.parentObj.tripID,
          mps: this.MPS,
          shipmenttype: 'lastmile',
          scanstage: this.scanStage
        }
        let result = await TripServices.validateMPSForNotScanned(input);
        if(result.data.code == 200){
          this.AWB = result.data.data.awb
          this.mpsError = ''
        }else{
          this.AWB = ''
          this.mpsError = result.data.message
        }
      }
    },

    async saveMPSDamgeOrPilferage(){
      if(this.checkValidation()){
        return false
      }
      this.isDamageLoader = true
      let input = {
        tripid: this.parentObj.tripID,
        allocationtype: 'lastmile',
        awb: this.AWB,
        mps: this.MPS,
        depstype: this.DEPSType,
        createdby: this.userName,
        scanstage: this.scanStage,
        imagearray: this.imagearray,
        userid: this.userID
      }
      // if(this.DEPSType == 'Damage'){
      //   input.loadinvehicle = Number(this.LoadInVehicle)
      // }else{
      //   input.loadinvehicle = 0
      // }
      let result = await TripServices.saveMPSDamgeOrPilferage(input);
      if(result.data.code == 200){
        this.$alert(result.data.message, "", "success");
        this.resetDamageField()
        this.getDamageOrPilferageMpsData()
        this.getNotScannedMpsData()
      }else{
        this.$alert(result.data.message, "", "error");
      }
      this.isDamageLoader = false
    },
    async removeMPSFromShort(mps) {
      this.isShortageLoader = true
      try {
        let payload = {
          tripid: mps.tripid,
          mps: mps.mps,
          scanstage: this.scanStage,
          shipmenttype: 'lastmile',
        }
        let data = await TripServices.RemoveShortMps(payload)
        if(data.data.code == 200){
          await this.getMarkShortMPSData()
        }else{
          this.$alert(result.data.message, "", "error");
        }
        this.isShortageLoader = false
      } catch (error) {
        this.isShortageLoader = false
        console.log(error);
      }
    },
    resetDamageField(){
      this.AWB = ''
      this.MPS = ''
      this.DEPSType = ''
      this.LoadInVehicle = ''
      this.imagearray = []

    },

    checkValidation(){
      let err = 0
      if(!this.AWB){
        err = 1
        this.mpsError = 'MPS is Required'
      }else{
        this.mpsError = ''
      }
      if(!this.DEPSType){
        err = 1
        this.depsTypeErr = 'Deps Type is Required'
      }
      // else{
      //   this.depsTypeErr = ''
      //   if(this.DEPSType == 'Damage' && !(this.LoadInVehicle)){
      //     err = 1
      //     this.loadErr = 'Load In Vehicle Required'
      //   }else{
      //     this.loadErr = ''
      //   }
      // }
      if(this.imagearray.length == 0){
        err = 1
        this.imageerr = 'Please select image'
      }
      else if(this.imagearray.length > 6){
        err = 1
        this.imageerr = 'Maximum 6 images allowed'
      }
      else{
        this.imageerr = ''
      }
      return err
    },

    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ['bg-primary', 'text-blue']
      } else {
        return ['bg-light', 'text-info']
      }
    },
    expandAll(){
      this.expanded = true;
      for (var key in this.accordianTab) {
        this.accordianTab[key] = true;
      }
    },
    collapseAll(){
      this.expanded = false;
      for (var key in this.accordianTab) {
        this.accordianTab[key] = false;
      }
    },
    toggleCheck(tabid){
      this.expanded = false;
      for (var key in this.accordianTab) {
        if(tabid != key){
          this.accordianTab[key] = false;
        }
      }
    },

    getCustomTableEvent(){

    },
    CloseTrip(){
      this.closeTrip =true;
    },
    showStartTrip() {
      this.$emit("goBackToParent")
    },
    callParent() {
        this.closeTrip = false;
      },


  }
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/TripManagement/CreateTripManagement/depsStartTrip/depsStartTrip.component.js